import { endOfWeek, startOfWeek } from 'date-fns';
const getWeekRange = (date) => {
  let currentDate = date ? new Date(date) : new Date();
  return {
    startDate: startOfWeek(currentDate, { weekStartsOn: 1 }),
    endDate: endOfWeek(currentDate, { weekStartsOn: 1 }),
  };
};

export default getWeekRange;
